import {IPriceCitiesSummary} from "./get_cities_data";

export const calculateAvgPrices = (citiesData?: IPriceCitiesSummary[]) => {
    let allOffers = 0;
    let oldAllOffers = 0;
    let generalAvgPrice = 0;
    let generalAvgM2Price = 0;
    let generalOldAvgPrice = 0;
    let generalOldAvgM2Price = 0;

    if (citiesData) {
        allOffers = citiesData.reduce((acc, curr) => (acc += curr.availableOffers), 0);
        oldAllOffers = citiesData.reduce((acc, curr) => (acc += curr.oldAvailableOffers), 0);
        generalAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.avgPrice * curr.availableOffers), 0) / allOffers;
        generalAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.avgPriceM2 * curr.availableOffers), 0) / allOffers;
        generalOldAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPrice * curr.oldAvailableOffers), 0) / oldAllOffers;
        generalOldAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPriceM2 * curr.oldAvailableOffers), 0) / oldAllOffers;
    }

    return {
        allOffers,
        generalAvgPrice,
        generalAvgM2Price,
        generalOldAvgPrice,
        generalOldAvgM2Price
    };
};
import {IPriceCitiesSummary} from "./get_cities_data";

export const calculateAvgPrices = (citiesData?: IPriceCitiesSummary[]) => {
    let allOffers = 0;
    let oldAllOffers = 0;
    let generalAvgPrice = 0;
    let generalAvgM2Price = 0;
    let generalOldAvgPrice = 0;
    let generalOldAvgM2Price = 0;

    if (citiesData) {
        allOffers = citiesData.reduce((acc, curr) => (acc += curr.availableOffers), 0);
        oldAllOffers = citiesData.reduce((acc, curr) => (acc += curr.oldAvailableOffers), 0);
        generalAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.avgPrice * curr.availableOffers), 0) / allOffers;
        generalAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.avgPriceM2 * curr.availableOffers), 0) / allOffers;
        generalOldAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPrice * curr.oldAvailableOffers), 0) / oldAllOffers;
        generalOldAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPriceM2 * curr.oldAvailableOffers), 0) / oldAllOffers;
    }

    return {
        allOffers,
        generalAvgPrice,
        generalAvgM2Price,
        generalOldAvgPrice,
        generalOldAvgM2Price
    };
};
